// =======================
// src/componentes/feedback/FeedbackInline.jsx
// =======================

import React from "react";

import { Alert, Box, Typography } from "@mui/material";

import {
  feedbackInlineBase,
  feedbackInlinePorTipo,
  mensagemFeedbackInline,
  tituloFeedbackInline,
} from "../../estilos/feedbacks";

const TITULOS_PADRAO = {
  error: "Não foi possível concluir",
  warning: "Atenção",
  success: "Operação concluída",
  info: "Informação",
};

export default function FeedbackInline({
  tipo = "error",
  titulo,
  mensagem,
  onClose,
  sx = {},
}) {
  if (!mensagem) {
    return null;
  }

  const tipoValido = Object.prototype.hasOwnProperty.call(
    feedbackInlinePorTipo,
    tipo,
  )
    ? tipo
    : "error";

  const tituloExibido = titulo || TITULOS_PADRAO[tipoValido];

  return (
    <Alert
      severity={tipoValido}
      onClose={onClose}
      sx={{
        ...feedbackInlineBase,
        ...feedbackInlinePorTipo[tipoValido],
        ...sx,
      }}
    >
      <Box>
        {tituloExibido && (
          <Typography sx={tituloFeedbackInline}>{tituloExibido}</Typography>
        )}

        <Typography sx={mensagemFeedbackInline}>{mensagem}</Typography>
      </Box>
    </Alert>
  );
}
